import { useSetState, useDeepCompareEffect } from 'ahooks'
import { Image, ImageViewer } from 'antd-mobile'
import { cloneDeep } from 'lodash-es'
import { toJS } from 'mobx'
import { useLocalStore, observer } from 'mobx-react-lite'
import React, { useEffect, useState, Fragment } from 'react'

import dictStore from '@/store/global/dictStore'
import { getUserData } from '@/utils'

import { flowPreviewApi, flowInstNodeApi } from './service'

import './index.less'

const FlowPath: React.FC<any> = ({
  flowPreView,
  flowDetail,
  isPreview,
  details = null,
  isMovement = false
}) => {
  const useRData = getUserData()
  const renderAvatar = (x: any) => {
    if (x?.node_type === 'notifier' && x?.notify_status === 2) {
      return 'https://s.huiyunban.cn/1768555548472512512.png'
    }
    if (x?.node_type === 'notifier' && x?.notify_status === 1) {
      return 'https://s.huiyunban.cn/1764485845911343104.png'
    }
    if (x?.is_discard && x?.approval_status !== 'REVERTED') return ''
    if (x?.node_type === 'start') return 'https://s.huiyunban.cn/1764485845911343104.png'
    if (x?.approval_status === 'UNDER_APPROVAL' && x?.add_node_infos?.length) {
      return 'https://s.huiyunban.cn/1769555320272588800.png'
    }
    if (x?.approval_status === 'UNDER_APPROVAL') {
      return 'https://s.huiyunban.cn/1764541484658331648.png'
    }
    if (x?.approval_status === 'APPROVED' && x?.is_add_sign) {
      return 'https://s.huiyunban.cn/1764541329418752000.png'
    }
    if (x?.approval_status === 'APPROVED' && x?.is_transfer) {
      return 'https://s.huiyunban.cn/1764541329418752000.png'
    }
    if (x?.approval_status === 'APPROVED') return 'https://s.huiyunban.cn/1764485845911343104.png'
    if (x?.approval_status === 'NOT_ARPROVED') {
      return 'https://s.huiyunban.cn/1768555548472512512.png'
    }
    if (x?.approval_status === 'TRANSFERED') return 'https://s.huiyunban.cn/1769555320272588800.png'
    if (x?.approval_status === 'REVERTED') return 'https://s.huiyunban.cn/1769633373178826752.png'
    if (x?.approval_status === 'DIRECT_NOT_APPROVED') {
      return 'https://s.huiyunban.cn/1768555548472512512.png'
    }
    return ''
  }

  const mapStatus: Record<string, string> = {
    APPROVED: '已同意',
    NOT_ARPROVED: '已拒绝',
    DIRECT_NOT_APPROVED: '直接拒绝',
    DIRECT_APPROVED: '直接同意'
  }

  const mapNodeTypeColor: Record<string, string> = {
    start: 'linear-gradient(180deg, #4C76F4 0%, #3862E7 100%)',
    approver: 'linear-gradient(180deg, #62D5BC 0%, #56BDA7 100%)',
    notifier: 'linear-gradient(180deg, #4C76F4 0%, #3862E7 100%)'
    // notifier: 'linear-gradient(180deg, #8A5CEE 0%, #7336F4 100%)'
  }

  const store = useLocalStore(() => dictStore)

  const approvalMode: any[] = store.getOptions('APPROVAL_METHOD') || []
  const [preview, setPreview] = useState<any>([])
  const [flow, setFlow] = useState<any>({})
  const [{ visible, imgurl }, setState] = useSetState({
    visible: false,
    imgurl: ''
  })

  const fetchflowPreview = async () => {
    return await flowPreviewApi(flowPreView)
  }

  const fetchFlowInstNode = async () => {
    const { code, data } = await flowInstNodeApi(flowDetail?.workflow_inst_id)
    setFlow(code === 2000 ? data : [])
  }

  const fetchflowPreView = async (info: any) => {
    const { code, data } = await flowPreviewApi({ ...flowPreView, ...info })
    setPreview(code === 2000 ? data : [])
  }
  useDeepCompareEffect(() => {
    console.log('useDeepCompareEffect--1-isMovement', isMovement)
    if (!isMovement) {
      if (!isPreview && flowDetail?.workflow_inst_id && flowDetail?.workflow_inst_id !== '0') {
        fetchFlowInstNode()
      } else if (
        isPreview &&
        Object.keys(flowPreView).length > 1 &&
        !!flowPreView?.apply_category_code
      ) {
        console.log('useDeepCompareEffect--3-isMovement', isMovement)
        fetchflowPreView({ details: details?.length > 0 ? details : null })
      }
    }
  }, [flowDetail, flowPreView, isPreview])
  console.log(isMovement, 'useDeepCompareEffect--4-isMovement')
  useDeepCompareEffect(() => {
    console.log(
      isMovement,
      isPreview,
      Object.keys(flowPreView).length > 1,
      !!flowPreView?.apply_category_code,
      'useDeepCompareEffect--2-isMovement'
    )
    if (
      // isMovement &&
      isPreview &&
      Object.keys(flowPreView).length > 1 &&
      !!flowPreView?.apply_category_code
    ) {
      fetchflowPreView({ details: details?.length > 0 ? details : null })
    }
  }, [details])
  const renderPreViewNodeName = (item: any) => {
    const { node_type = '', approval_mode = '', processor_list = [], approval_type } = item
    if (node_type === 'start') return '我'
    if (approval_type === 'AUTOMATIC_APPROVAL') return '自动通过'
    if (approval_type === 'AUTOMATIC_REJECTION') return '自动拒绝'
    if (approval_type === 'THIRD_PARTY_APPROVAL') return '第三方审批'
    if (node_type === 'approver') {
      return (
        <span>
          {approvalMode.find((z) => z.value === approval_mode)?.name}：
          {processor_list.map((x) => x.processor_name)?.join('、')}
        </span>
      )
    }
    if (node_type === 'notifier') {
      return <span>{processor_list.map((x) => x.processor_name)?.join('、')}</span>
    }
  }

  const renderEndColor = () => {
    if (flow?.approval_status === 'UNDER_APPROVAL') return '#D8D8D8'
    if (flow?.approval_status === 'APPROVED' || flow?.approval_status === 'DIRECT_APPROVED') {
      return '#52C41A'
    }
    if (
      flow?.approval_status === 'NOT_ARPROVED' ||
      flow?.approval_status === 'DIRECT_NOT_APPROVED'
    ) {
      return '#FF4D4F'
    }
    return '#D8D8D8'
  }

  const renderAddNode = (add_node_infos: any[], approval_status: any) => {
    return (
      <>
        {add_node_infos?.length > 0 &&
          add_node_infos?.map((x, index) => {
            const length: number = x?.processor?.length || 0
            return (
              <div key={index} style={{ marginBottom: 5 }}>
                <div className='path-item-ii-title'>
                  <div className='approval-process-show-item'>
                    <div className='approval-process-show-item-title'>
                      {x?.handle_processor_name || ''}（加签：{x?.processor?.[0]?.name || ''}
                      {length > 1 ? (
                        <span className='approval-process-show-item-title-span'>{`等${length}人`}</span>
                      ) : (
                        ''
                      )}
                      审批）
                    </div>
                    <div className='approval-process-show-item-time'>
                      {approval_status !== 'UNDER_APPROVAL' ? '' : x?.handle_time || ''}
                    </div>
                  </div>
                </div>
                <div className='path-item-ii-s'>审批意见：{x?.comment || ''}</div>
                {x?.attachments?.map((y: any) => (
                  <div key={y?.image_url} className='path-item-ii-a'>
                    <Image
                      onClick={() => setState({ visible: true, imgurl: y.image_url })}
                      className='path-item-ii-a-img'
                      src={y?.image_url}
                    />
                    <div className='path-item-ii-a-file'>
                      <div className='path-item-ii-a-file-name'>{y?.name || ''}</div>
                      <div>{(parseFloat(y?.size) / 1024)?.toFixed(2)}kb</div>
                    </div>
                  </div>
                ))}
              </div>
            )
          })}
      </>
    )
  }
  /**
   * 判断数组是否包含一个对象且该对象有approval_time属性
   * @param arr - 要检查的数组
   * @returns boolean - 如果数组包含一个对象且该对象有approval_time属性则返回true，否则返回false
   */
  const isArrayWithApprovalTime = (arr: any[]): boolean => {
    // 检查是否为数组且长度为1
    if (!Array.isArray(arr) || arr.length !== 1) {
      return false
    }
    const item = arr?.[0]?.is_approved
    // 检查数组中的元素是否为对象且包含approval_time属性
    return item?.is_approved && !!item?.approval_time
  }

  const renderNodeName = (item: any) => {
    const {
      notify_status = 0,
      node_type = '',
      processor_list = [],
      approval_status = '',
      created_at,
      transfer_info = {},
      handle_time,
      revert_processor_name,
      revert2_node_name,
      revert_comment,
      revert_attachments,
      add_node_infos,
      approval_type,
      revert_time
    } = item
    let name = ''
    let tip = ''
    let time = ''
    if (node_type === 'start') {
      name = processor_list?.[0]?.processor_name
      tip = '（已提交）'
      // time = `提交时间： ${created_at}`
    }

    if (approval_type === 'AUTOMATIC_APPROVAL') {
      tip = '自动通过'
    }
    if (approval_type === 'AUTOMATIC_REJECTION') {
      tip = '自动拒绝'
    }
    if (approval_type === 'THIRD_PARTY_APPROVAL') {
      tip = '第三方审批'
    }
    const clone_extend_infos = cloneDeep(flow?.extend_infos)
    const new_extend_infos =
      clone_extend_infos?.map((item: any) => item?.direct_handle_processor) || []
    if (
      (approval_status === 'APPROVED' ||
        approval_status === 'NOT_ARPROVED' ||
        approval_status === 'DIRECT_NOT_APPROVED' ||
        approval_status === 'DIRECT_APPROVED') &&
      approval_type === 'MANUAL_APPROVAL'
      // approval_mode === 'OR_SIGN'
    ) {
      const { extend_infos = [], direct_handle_processor } = flow
      const approver_infos = extend_infos?.filter(
        (y: any) => !['REVOKED', 'VOIDED'].includes(y.direct_handle_result_status)
      )
      const _processor_list: any[] =
        processor_list?.filter((x: any) => x.processor_id !== direct_handle_processor) || []
      const bool_pro = _processor_list?.length + approver_infos?.length === 1
      const renderTitle = (x: any) => {
        name = x?.processor_name
        const bool = new_extend_infos?.includes(x.processor_id)
        if (approval_status === 'DIRECT_APPROVED' && bool) {
          tip = '（直接同意）'
        } else if (
          approval_status === 'APPROVED' ||
          (approval_status === 'DIRECT_APPROVED' && !bool)
        ) {
          tip = '（已同意）'
        } else if (approval_status === 'DIRECT_NOT_APPROVED' && bool) {
          tip = '（直接拒绝）'
        } else if (
          approval_status === 'NOT_ARPROVED' ||
          (approval_status === 'DIRECT_NOT_APPROVED' && !bool)
        ) {
          tip = '（已拒绝）'
        }
        // tip = `（${mapStatus?.[approval_status] || ''}）`
        time = approval_status !== 'UNDER_APPROVAL' ? '' : `${x?.approval_time || ''}`
        if (!x?.is_approved) return name
        // return <>{`${name}${tip}${time}`}</>
        return (
          <div className='approval-process-show-item'>
            <div className='approval-process-show-item-title'>{`${name}${tip}`}</div>
            <div className='approval-process-show-item-time'>{`${time}`}</div>
          </div>
        )
      }
      const renderDirectName = (extend_info: any) => {
        const _name: string = extend_info?.direct_handle_processor_name
        const _time: string =
          approval_status !== 'UNDER_APPROVAL' ? '' : `${extend_info?.approval_time || ''}`
        const _tip: string = `（${mapStatus?.[approval_status]}）` || ''
        // return `${_name}${_time}${_tip}`
        return (
          <div className='approval-process-show-item'>
            <div className='approval-process-show-item-title'>{`${_name}${_tip}`}</div>
            <div className='approval-process-show-item-time'>{`${_time}`}</div>
          </div>
        )
      }

      return (
        <div>
          {(approval_status === 'DIRECT_APPROVED' || approval_status === 'DIRECT_NOT_APPROVED') && (
            <>
              {approver_infos?.map((x: any) => (
                <Fragment key={x.approval_time}>
                  <div className='path-item-ii-title'>{renderDirectName(x)}</div>
                  <div className='path-item-ii-s van-multi-ellipsis--l2'>
                    审批意见：{x?.comment || ''}
                  </div>

                  {x?.attachments111?.map((x_: any, i: number) => (
                    <div className='path-item-ii-a' key={`path-item-ii-a${i}`}>
                      <Image
                        onClick={() => setState({ visible: true, imgurl: x_.image_url })}
                        className='path-item-ii-a-img'
                        src={x_?.image_url}
                      />
                      <div className='path-item-ii-a-file'>
                        <div className='path-item-ii-a-file-name'>{x_?.name}</div>
                        <div>
                          {(parseFloat(x_?.size) / 1024)?.toFixed(2)}kb{parseFloat(x_?.size)}-
                          {parseFloat(x_?.size) / 1024}
                        </div>
                      </div>
                    </div>
                  ))}
                </Fragment>
              ))}
            </>
          )}

          {renderAddNode(add_node_infos, approval_status)}

          {_processor_list.map((x) => (
            <Fragment key={x?.id}>
              <div className='path-item-ii-title'>{renderTitle(x)}</div>
              {x?.is_approved > 0 && (
                <div className='path-item-ii-s'>审批意见：{x?.approval_comment}</div>
              )}
              {x?.is_approved > 0 &&
                x?.attachments?.map((y) => (
                  <div key={y.image_url} className='path-item-ii-a'>
                    <Image
                      onClick={() => setState({ visible: true, imgurl: y.image_url })}
                      className='path-item-ii-a-img'
                      src={y.image_url}
                    />
                    <div className='path-item-ii-a-file'>
                      <div className='path-item-ii-a-file-name'>{y?.name}</div>
                      <div>{(parseFloat(y?.size) / 1024)?.toFixed(2)}kb</div>
                    </div>
                  </div>
                ))}
            </Fragment>
          ))}
        </div>
      )
    }
    // if (
    //   (approval_status === 'APPROVED' ||
    //     approval_status === 'NOT_ARPROVED' ||
    //     approval_status === 'DIRECT_NOT_APPROVED' ||
    //     approval_status === 'DIRECT_APPROVED') &&
    //   approval_mode === 'AND_SIGN'
    // ) {
    //   const renderTitle = (x) => {
    //     name = x?.processor_name
    //     tip = `（${mapStatus?.[approval_status] || ''}）`
    //     time = `审批时间： ${x?.approval_time || ''}`
    //     if (!x?.is_approved) return name
    //     return <>{`${name}${tip}${time}`}</>
    //   }

    //   const _display_processor_list: Array<any> =
    //     approval_status === 'NOT_ARPROVED'
    //       ? processor_list.filter((x) => x?.is_approved)
    //       : processor_list

    //   return (
    //     <div>
    //       {_display_processor_list?.map((x) => (
    //         <Fragment key={x?.parent_id}>
    //           {/* {x?.is_approved > 0 && <div>{`${x?.processor_name}${_tip} 审批时间： ${x?.approval_time || ''}`}</div>} */}
    //           <div>{renderTitle(x)}</div>
    //           {x?.is_approved > 0 && (
    //             <div className='path-item-ii-s'>审批意见：{x?.approval_comment || ''}</div>
    //           )}
    //           {x?.is_approved > 0 &&
    //             x?.attachments?.map((y) => (
    //               <div key={y?.image_url} className='path-item-ii-a'>
    //                 <Image className='path-item-ii-a-img' src={y?.image_url} />
    //                 <div className='path-item-ii-a-file'>
    //                   <div className='path-item-ii-a-file-name'>{y?.name || ''}</div>
    //                   <div>{parseFloat(y?.size / 1024)?.toFixed(2)}kb</div>
    //                 </div>
    //               </div>
    //             ))}
    //         </Fragment>
    //       ))}
    //     </div>
    //   )
    // }
    if (approval_status === 'IN_PROCESS') {
      const renderTitle = (x: any) => {
        if (x?.is_approved) {
          return (
            <div className='approval-process-show-item'>
              <div className='approval-process-show-item-title'>
                {x?.processor_name || ''}（已同意）
              </div>
              <div className='approval-process-show-item-time'>{`${approval_type !== 'MANUAL_APPROVAL' ? '' : x?.approval_time || ''}`}</div>
            </div>
          )
        }
        return <>{x?.processor_name || ''}</>
      }
      return (
        <div>
          {renderAddNode(add_node_infos, approval_status)}
          {processor_list?.map((x: any) => (
            <Fragment key={x?.parent_id}>
              <div style={{ marginBottom: 5 }}>{renderTitle(x)}</div>
              {!!x?.is_approved && (
                <div className='path-item-ii-s'>审批意见：{x?.approval_comment || ''}</div>
              )}
              {!!x?.is_approved &&
                x?.attachments?.map((y: any) => (
                  <div key={y?.image_url} className='path-item-ii-a'>
                    <Image
                      onClick={() => setState({ visible: true, imgurl: y.image_url })}
                      className='path-item-ii-a-img'
                      src={y?.image_url}
                    />
                    <div className='path-item-ii-a-file'>
                      <div className='path-item-ii-a-file-name'>{x?.name}</div>
                      <div>{(parseFloat(y?.size) / 1024)?.toFixed(2)}kb</div>
                    </div>
                  </div>
                ))}
            </Fragment>
          ))}
        </div>
      )
    }
    if (approval_status === 'UNDER_APPROVAL') {
      const renderTitle = (x: any) => {
        if (x?.is_approved) {
          return (
            <div className='approval-process-show-item'>
              <div className='approval-process-show-item-title'>
                {x?.processor_name || ''}（已同意）
              </div>
              <div className='approval-process-show-item-time'>{`${approval_status !== 'UNDER_APPROVAL' ? '' : x?.approval_time || ''}`}</div>
            </div>
          )
        }
        if (!x?.is_approved && !['REVOKED', 'VOIDED'].includes(flow?.approval_status)) {
          return (
            <>
              {x?.processor_name || ''}
              审批中，已等待
              <span style={{ color: '#0256FF' }}>
                {(x?.wait_time !== null && String(x?.wait_time)) || ''}
              </span>
              小时
            </>
          )
        }
        return <>{x?.processor_name || ''}</>
      }

      return (
        <div>
          {/* <>
            {add_node_infos?.length > 0 &&
              add_node_infos?.map((x, index) => {
                const length: number = x?.processor?.length || 0
                const _tip = (
                  <>
                    （加签：{x?.processor?.[0]?.name || ''}
                    {length > 1 ? <span style={{ color: '#0256FF' }}>{`等${length}人`}</span> : ''}
                    审批）
                  </>
                )
                return (
                  <div key={index} style={{ marginBottom: 5 }}>
                    <div>
                      {_tip}加签时间：{x?.handle_time}
                    </div>
                    <div className='path-item-ii-s'>审批意见：{x?.comment || ''}</div>
                    {x?.attachments?.map((y) => (
                      <div key={y?.image_url} className='path-item-ii-a'>
                        <Image className='path-item-ii-a-img' src={y?.image_url} />
                        <div className='path-item-ii-a-file'>
                          <div className='path-item-ii-a-file-name'>{y?.name || ''}</div>
                          <div>{parseFloat(y?.size / 1024)?.toFixed(2)}kb</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              })}
          </> */}

          {renderAddNode(add_node_infos, approval_status)}

          {processor_list?.map((x: any) => (
            <Fragment key={x?.parent_id}>
              <div style={{ marginBottom: 5 }}>
                {/* {x?.processor_name} */}
                {renderTitle(x)}
              </div>
              {!!x?.is_approved && (
                <div className='path-item-ii-s'>审批意见：{x?.approval_comment || ''}</div>
              )}
              {!!x?.is_approved &&
                x?.attachments?.map((y: any) => (
                  <div key={y?.image_url} className='path-item-ii-a'>
                    <Image
                      onClick={() => setState({ visible: true, imgurl: y.image_url })}
                      className='path-item-ii-a-img'
                      src={y?.image_url}
                    />
                    <div className='path-item-ii-a-file'>
                      <div className='path-item-ii-a-file-name'>{x?.name}</div>
                      <div>{(parseFloat(y?.size) / 1024)?.toFixed(2)}kb</div>
                    </div>
                  </div>
                ))}
            </Fragment>
          ))}
        </div>
      )
    }

    if (approval_status === 'TRANSFERED') {
      const _name = transfer_info?.handle_processor_name
      const _time = `${handle_time || ''}`
      const length: number = transfer_info?.processor?.length || 0
      const name_tip = `${_name}（转签：${transfer_info?.processor?.[0]?.name || ''}`

      const _processor_list: any[] =
        processor_list.filter((x: any) => x?.processor_id !== transfer_info?.handle_processor_id) ||
        []
      const renderTitle = (x: any) => {
        if (x?.is_approved) {
          return (
            <div className='approval-process-show-item'>
              <div className='approval-process-show-item-title'>
                {x?.processor_name || ''}（已同意）
              </div>
              <div className='approval-process-show-item-time'>{`${approval_status !== 'UNDER_APPROVAL' ? '' : x?.approval_time || ''}`}</div>
            </div>
          )
        }
        if (!x?.is_approved) return <>{x?.processor_name}</>
      }

      return (
        <>
          <div>
            <div className='approval-process-show-item'>
              <div className='approval-process-show-item-title'>
                {name_tip}
                {length > 1 ? (
                  <span className='approval-process-show-item-title-span'>{`等${length}人`}</span>
                ) : (
                  ''
                )}
                审批）
              </div>
              <div className='approval-process-show-item-time'>
                {approval_status !== 'UNDER_APPROVAL' ? '' : _time}
              </div>
            </div>
          </div>
          {renderAddNode(add_node_infos, approval_status)}
          <div className='path-item-ii-s'>审批意见：{transfer_info?.comment || ''}</div>
          {transfer_info?.attachments?.map((x: any) => (
            <div className='path-item-ii-a'>
              <Image
                onClick={() => setState({ visible: true, imgurl: x?.image_url })}
                className='path-item-ii-a-img'
                src={x?.image_url}
              />
              <div className='path-item-ii-a-file'>
                <div className='path-item-ii-a-file-name'>{x?.name}</div>
                <div>{(parseFloat(x?.size) / 1024)?.toFixed(2)}kb</div>
              </div>
            </div>
          ))}
          <div>
            {_processor_list?.map((x) => (
              <Fragment key={x?.parent_id}>
                <div style={{ marginBottom: 5 }}>{renderTitle(x)}</div>
                {!!x?.is_approved && (
                  <div className='path-item-ii-s'>审批意见：{x?.approval_comment || ''}</div>
                )}
                {!!x?.is_approved &&
                  x?.attachments?.map((y: any) => (
                    <div key={y?.image_url} className='path-item-ii-a'>
                      <Image
                        onClick={() => setState({ visible: true, imgurl: y?.image_url })}
                        className='path-item-ii-a-img'
                        src={y?.image_url}
                      />
                      <div className='path-item-ii-a-file'>
                        <div className='path-item-ii-a-file-name'>{x?.name}</div>
                        <div>{(parseFloat(y?.size) / 1024)?.toFixed(2)}kb</div>
                      </div>
                    </div>
                  ))}
              </Fragment>
            ))}
          </div>
        </>
      )
    }

    if (approval_status === 'REVERTED') {
      // const _time = `审批时间：${revert_time || ''}`

      return (
        <>
          <div className='approval-process-show-item'>
            <div className='approval-process-show-item-title'>
              {revert_processor_name}
              {`（回退至-${revert2_node_name || ''}）`}
              {/* {_time} */}
            </div>
          </div>
          {revert_comment && <div className='path-item-ii-s'>审批意见：{revert_comment || ''}</div>}
          {revert_attachments?.map((x: any) => (
            <div className='path-item-ii-a'>
              <Image
                onClick={() => setState({ visible: true, imgurl: x?.image_url })}
                className='path-item-ii-a-img'
                src={x?.image_url}
              />
              <div className='path-item-ii-a-file'>
                <div className='path-item-ii-a-file-name'>{x?.name}</div>
                <div>{(parseFloat(x?.size) / 1024)?.toFixed(2)}kb</div>
              </div>
            </div>
          ))}
        </>
      )
    }

    // if (approval_status === 'DIRECT_NOT_APPROVED') {

    // }

    if (node_type === 'notifier') {
      const notify_text =
        node_type === 'notifier'
          ? `${notify_status === 0 ? '抄送' : notify_status === 1 ? '已抄送' : '未抄送'}${processor_list?.length}人`
          : ''
      const processor_name_text = processor_list?.map((p: any) => p?.processor_name)?.join('、')
      const processor_name =
        node_type === 'notifier' ? `（${processor_name_text}）` : processor_name_text
      return (
        <>
          {renderAddNode(add_node_infos, approval_status)}
          <div>
            {notify_text}
            {processor_name}
          </div>
        </>
      )
      // (
      //   <div>
      //     {processor_list?.map((x) => (
      //       <div key={x?.parent_id} style={{ marginBottom: 5 }}>
      //         {x?.processor_name}{' '}
      //         {approval_status === 'NO_ACTION_REQUIRED' && node_type === 'notifier' && '（已抄送）'}
      //       </div>
      //     ))}
      //   </div>
      // )
    }

    if (node_type === 'start' && useRData?.employee_id === processor_list?.[0]?.processor_id) {
      name = '我'
    }
    return `${name}${tip}${time}`
  }

  const renderAvatarName = (item: any) => {
    const { node_type = '', processor_list = [], approval_type } = item

    if (node_type === 'start') return processor_list?.[0]?.processor_name?.substr(-2)
    if (node_type === 'start' && useRData?.employee_id === processor_list?.[0]?.processor_id) {
      return '我'
    }
    if (approval_type === 'AUTOMATIC_APPROVAL' || approval_type === 'AUTOMATIC_REJECTION') {
      return '自动'
    }
    if (approval_type === 'THIRD_PARTY_APPROVAL') return '三方'
    return processor_list?.[0]?.processor_name?.substr(-2)
  }
  const renderEmptyPreView = () => {
    if (
      flowPreView?.application_mode === 'AGENT_INITIATED' &&
      flowPreView?.employee_ids?.length > 1
    ) {
      return <div className='path-empty'>当前审批流程为申请人流程，提交后可见</div>
    }
    return ''
  }

  const renderDoneMapInfo = (extend_infos: any[], approval_status: string) => {
    return extend_infos?.find((x) => x.direct_handle_result_status === approval_status) || {}
  }

  const renderDoneText = () => {
    const { approval_status = '', extend_infos, updated_at } = flow

    const doneMap = renderDoneMapInfo(extend_infos, approval_status)
    if (
      approval_status === 'REVOKED' &&
      useRData?.employee_id === doneMap?.direct_handle_processor
    ) {
      return `我 （已作废）作废时间：${updated_at}`
    }
    if (approval_status === 'REVOKED') {
      return `${doneMap?.direct_handle_processor_name || ''}（已作废）作废时间：${updated_at}`
    }
    if (
      approval_status === 'VOIDED' &&
      useRData?.employee_id === doneMap?.direct_handle_processor
    ) {
      return `我 （已撤销）撤销时间：${updated_at}`
    }
    if (approval_status === 'VOIDED') {
      return `${doneMap?.direct_handle_processor_name || ''}（已撤销）撤销时间：${updated_at}`
    }
    if (approval_status === 'APPROVED') {
      return '已通过'
    }
    if (approval_status === 'DIRECT_NOT_APPROVED') {
      return `${doneMap?.direct_handle_processor_name} （直接拒绝）`
    }
    if (approval_status === 'DIRECT_APPROVED') {
      return `${doneMap?.direct_handle_processor_name} （直接同意）`
    }
    if (approval_status === 'NOT_ARPROVED') {
      return `${doneMap?.direct_handle_processor_name} （已拒绝）`
    }
    return ''
  }

  console.log(flowPreView, preview, flow, 'flowPreView', toJS(approvalMode), flow, isPreview)
  const renderTime = (item: any) => {
    // 根据流程状态显示不同时间
    switch (item?.approval_status) {
      case 'IN_PROCESS':
      case 'UNDER_APPROVAL':
        // 回退状态显示回退时间
        return ''
      default:
        return item?.updated_at || ''
    }
  }
  // const renderTime = (item: any) => {
  //   // 起始节点显示创建时间
  //   if (item?.node_type === 'start') {
  //     return item?.created_at || ''
  //   }
  //   // 抄送节点显示通知时间
  //   if (item?.node_type === 'notifier') {
  //     return item?.notify_time || ''
  //   }
  //   const processor_list = cloneDeep(item?.processor_list)
  //   const transferProcessorList =
  //     processor_list?.filter(
  //       (x: any) => x?.processor_id !== item?.transfer_info?.handle_processor_id
  //     ) || []
  //   const processorList = item?.processor_list || []
  //   // 根据流程状态显示不同时间
  //   switch (flow?.approval_status) {
  //     case 'REVERTED':
  //       // 回退状态显示回退时间
  //       return item?.revert_time || ''
  //     case 'REVOKED':
  //     case 'VOIDED':
  //       // 作废/撤销状态显示更新时间
  //       return flow?.updated_at || ''
  //     case 'TRANSFERED':
  //       // 转签状态处理
  //       return isArrayWithApprovalTime(transferProcessorList)
  //         ? transferProcessorList[0]?.approval_time
  //         : ''
  //     case 'UNDER_APPROVAL':
  //       // 审批中状态处理
  //       return isArrayWithApprovalTime(processorList) ? processorList[0]?.approval_time : ''
  //     case 'APPROVED':
  //     case 'NOT_ARPROVED':
  //     case 'DIRECT_NOT_APPROVED':
  //     case 'DIRECT_APPROVED':
  //       // 已完成状态且为手动审批时处理
  //       if (item?.approval_type === 'MANUAL_APPROVAL') {
  //         const processor_list_new = cloneDeep(item?.processor_list)
  //         const filteredProcessorList =
  //           processor_list_new?.filter(
  //             (x: any) => x.processor_id !== flow?.direct_handle_processor
  //           ) || []
  //         const approverList =
  //           flow?.extend_infos?.filter(
  //             (y: any) => !['REVOKED', 'VOIDED'].includes(y?.direct_handle_result_status)
  //           ) || []
  //         // 只有一个审批人时显示审批时间
  //         if (filteredProcessorList.length + approverList.length === 1) {
  //           if (approverList.length === 1) {
  //             return approverList[0]?.approval_time || ''
  //           }
  //           if (filteredProcessorList.length === 1) {
  //             return filteredProcessorList[0]?.approval_time || ''
  //           }
  //         }
  //       }
  //       return ''
  //     default:
  //       return ''
  //   }
  // }
  return (
    <div className='path'>
      {!isPreview &&
        flow?.node_list?.map((x: any, xIndex: any) => (
          <div key={`${x.id}-${xIndex}`} className='path-item'>
            <div className='path-item-i'>
              <div
                className='path-item-i-avatar'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: mapNodeTypeColor[x?.node_type]
                }}
              >
                {x?.node_type === 'notifier' ? (
                  <img
                    style={{ width: '24px', height: '19.5px' }}
                    src='https://s.huiyunban.cn/1966414289371664384.png'
                  />
                ) : (
                  renderAvatarName(x)
                )}
                {renderAvatar(x) && (
                  <Image className='path-item-i-avatar-status' src={renderAvatar(x)} />
                )}
              </div>
              <div className='path-item-i-detail'>
                <div className='path-item-i-detail-n'>
                  <div className='path-item-i-detail-n-text'>
                    {x?.node_type === 'start'
                      ? '发起申请'
                      : `${x?.node_name}${x?.is_discard ? '（作废）' : ''}`}
                  </div>
                  <div className='path-item-i-detail-n-time'>{renderTime(x)}</div>
                </div>
                <div className='path-item-i-detail-d'>{renderNodeName(x)}</div>
                <div className='path-item-i-detail-t'>
                  {x?.logs?.map((y: any, yIndex: number) => (
                    <div key={`${y.edit_time}-${yIndex}`}>
                      <div className='path-item-ii-t'>
                        {`${y?.editor}修改表单`} {y?.edit_time}
                      </div>
                      <div
                        key={`${y.image_url}-${yIndex}`}
                        className='path-item-ii-a'
                        onClick={() => setState({ visible: true, imgurl: y.snapshot_image?.url })}
                      >
                        <Image className='path-item-ii-a-img' src={y.snapshot_image?.url} />
                        <div className='path-item-ii-a-file'>
                          <div className='path-item-ii-a-file-name'>{y?.snapshot_image?.name}</div>
                          <div>{(parseFloat(y?.snapshot_image?.size) / 1024)?.toFixed(2)}kb</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='path-item-i-time'>{x?.approval_time}</div>
            </div>
            <div className='path-item-line' />
          </div>
        ))}

      {isPreview &&
        preview?.map((x: any) => (
          <div key={x?.id} className='path-item'>
            <div className='path-item-i'>
              <div
                className='path-item-i-avatar'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: mapNodeTypeColor[x?.node_type]
                }}
              >
                {x?.node_type === 'notifier' ? (
                  <img
                    style={{ width: '24px', height: '19.5px' }}
                    src='https://s.huiyunban.cn/1966414289371664384.png'
                  />
                ) : (
                  renderAvatarName(x)
                )}
              </div>
              <div className='path-item-i-detail'>
                <div className='path-item-i-detail-n'>
                  <div className='path-item-i-detail-n-text'>
                    {x?.node_type === 'start' ? '发起申请' : x?.node_name}
                  </div>
                  <div className='path-item-i-detail-n-time'>{renderTime(x)}</div>
                </div>
                <div className='path-item-i-detail-d'>{renderPreViewNodeName(x)}</div>
              </div>
            </div>
            <div className='path-item-ii'></div>
            <div className='path-item-line' />
          </div>
        ))}

      {isPreview && preview?.length > 0 ? (
        <div className='path-done'>
          <div className='path-done-img' style={{ border: '1px solid #D8D8D8' }}>
            <div className='path-done-img-dot' style={{ background: '#D8D8D8' }} />
          </div>
          <div className='path-done-text'>结束</div>
        </div>
      ) : (
        renderEmptyPreView()
      )}

      {!isPreview && flow?.node_list?.length > 0 && (
        <div className='path-done'>
          <div className='path-done-img' style={{ border: `1px solid ${renderEndColor()}` }}>
            <div className='path-done-img-dot' style={{ background: renderEndColor() }} />
          </div>
          <div className='path-done-text'>结束</div>
        </div>
      )}
      <div className='path-done-text-i'>{renderDoneText()}</div>
      <ImageViewer
        image={imgurl}
        visible={visible}
        onClose={() => setState({ visible: false, imgurl: '' })}
      />
    </div>
  )
}

export default observer(FlowPath)
